import React from 'react'

const WebinarIcon = (
  <>
    <path
      d="M23.625 38.5C16.335 38.5 10.625 35.425 10.625 31.5V18.5C10.625 17.947 11.073 17.5 11.625 17.5H35.625C36.177 17.5 36.625 17.947 36.625 18.5V31.5C36.625 35.425 30.915 38.5 23.625 38.5Z"
      fill="#444444"
    />
    <path
      d="M43.625 30.5C43.073 30.5 42.625 30.053 42.625 29.5V14.5C42.625 13.947 43.073 13.5 43.625 13.5C44.177 13.5 44.625 13.947 44.625 14.5V29.5C44.625 30.053 44.177 30.5 43.625 30.5Z"
      fill="#444444"
    />
    <path
      d="M23.625 26.5005C23.46 26.5005 23.295 26.4595 23.146 26.3785L1.146 14.3785C0.825 14.2035 0.625 13.8665 0.625 13.5005C0.625 13.1345 0.825 12.7975 1.146 12.6225L23.146 0.622477C23.445 0.460477 23.805 0.460477 24.104 0.622477L46.104 12.6225C46.425 12.7975 46.625 13.1345 46.625 13.5005C46.625 13.8665 46.425 14.2035 46.104 14.3785L24.104 26.3785C23.955 26.4595 23.79 26.5005 23.625 26.5005Z"
      fill="#5B5B5B"
    />
  </>
)

export default WebinarIcon
